import React from "react";
import HeaderBar from "../../HeaderBar/HeaderBar";

const SubAdminDashboard = () => {
  return (
    <div>
     <h1>SubAdminDashboard</h1>
    </div>
  );
}

export default SubAdminDashboard;